import { Component, OnInit } from '@angular/core';
import { EnvironmentActions } from '@app/core/actions';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromRoot from '@app/reducers';
import { first } from 'rxjs/operators';
import { DialogRef } from '@ngneat/dialog';

@Component({
  selector: 'app-modal-update',
  templateUrl: './modal-update.component.html',
  styleUrls: ['./modal-update.component.scss']
})
export class ModalUpdateComponent implements OnInit {
  updateRunning$: Observable<boolean>;
  updateRolesAndPoliciesSuccess$: Observable<boolean>;

  constructor(
    private readonly store$: Store<fromRoot.State>, public ref: DialogRef
  ) {
    this.updateRunning$ = this.store$.select(fromRoot.getUpdateRunning);
    this.updateRolesAndPoliciesSuccess$ = this.store$.select(fromRoot.getUpdateRolesAndPoliciesSuccess);
    this.updateRolesAndPoliciesSuccess$.pipe(first(domain => !!domain)).subscribe(() => this.closeModal());
  }

  ngOnInit(): void { }

  onSubmit() {
    this.store$.dispatch(EnvironmentActions.RunUpdates());
  }

  closeModal(): void {
    this.ref.close();
  }
}
